import * as React from 'react';
import { IndexRedirect, Route } from 'react-router';
import { makeGetComponent } from './utils';

export const getMobileRoute = () => (
  <Route path="m" getComponent={makeGetComponent('antd/AntMobileRoot')}>
    <IndexRedirect to="my-data-page" />
    <Route path="login" getComponent={makeGetComponent('LoginPage')} />

    <Route
      path="cart"
      getComponent={makeGetComponent('CartCheckoutPage/index')}
    />
    <Route
      path="subscribe/checkout"
      getComponent={makeGetComponent(
        'DataPaymentPage/DataPaymentPageContainer'
      )}
    />
    <Route
      path="my-data-page/search"
      getComponent={makeGetComponent(
        'SearchProductsUserPage/SearchProductsUserPageContainer'
      )}
    />
    <Route
      path="data-interest-form"
      getComponent={makeGetComponent(
        'DataInterestFormPage/DataInterestFormPageContainer'
      )}
    />
  </Route>
);



// WEBPACK FOOTER //
// ./app/routers/MobileRoute.tsx